import { toast as sonnerToast } from "sonner";

interface ToastOptions {
  duration?: number;
}

const defaultOptions: ToastOptions = {
  duration: 3000,
};

export const toast = {
  success: (message: string, options?: ToastOptions) => {
    sonnerToast.success(message, { ...defaultOptions, ...options });
  },
  error: (message: string, options?: ToastOptions) => {
    sonnerToast.error(message, { ...defaultOptions, ...options });
  },
  info: (message: string, options?: ToastOptions) => {
    sonnerToast.info(message, { ...defaultOptions, ...options });
  },
  warning: (message: string, options?: ToastOptions) => {
    sonnerToast.warning(message, { ...defaultOptions, ...options });
  },
}; 